<template>
  <div>
    <title-ribbon v-if="deActive" title="ارسال آگهی گروهی"></title-ribbon>
    <v-app>
      <div v-if="deActive" class="mt-10 pt-15 px-0 float-left">
        <extra-buttons></extra-buttons>
      </div>
      <div class="col-md-12 mx-auto">
        <div class=" " style="border: none!important;">
          <agency-category ref="category" :multiAdsCat="true" :page-name="namePage"
                           @category-schema="getSchema" @category-fields="getFields"></agency-category>
          <div class="col-md-12 my-0 py-0">
            <div class="col-md-8 mx-auto my-0 py-0">
              <city-selector ref="city" :force="true"></city-selector>
            </div>
            <div v-if="fields.length > 0" class="col-md-8 mx-auto my-0 py-0">
              <get-panels-number ref="number" :multiple-numbers="true"
                                 panel-type="divar_real_estate"></get-panels-number>
            </div>
          </div>
          <input-maker ref="inputs" :fields="this.fields" :param="schema" :ui_schema="this.ui_schema"
                       class="my-0 py-0"></input-maker>
          <div v-for="item in numbers" v-if="numbers.length > 0" :key="item"
               :data-number="item"
               class="col-md-12 my-0 mx-auto p-4">
            <v-card class="mt-3 pt-3">
              <p class="text-center">ثبت آگهی برای
                :{{ $refs.number.numbers.find((x) => x.id == item).phone }}</p>
              <div class="col-md-8 mx-auto my-0 py-0">
                <pic-selector :key="item" :ref="item" :count="10" :data-num="item"></pic-selector>
              </div>
              <inputs :key="item" :ref="item" :category="schema.category"
                      :city="schema.location.city" :has_price="$refs.category.multiFiltered.new_price || false "
                      class="my-0 py-0"></inputs>
            </v-card>
          </div>
          <div class="row">
            <div class="col-md-10 px-5 mr-2">
              <setting-ads :market="true" :time-require="true"></setting-ads>
              <v-btn :loading="loading" class="submit-btn float-left" @click="submitAds(0)">
                <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                ثبت آگهی
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
import Categoryselector from "@/view/pages/ads/categorySelector";
import CitySelector from "@/view/pages/ads/citySelector";
import NumberSelector from "@/view/pages/ads/numberSelector";
import Inputs from "@/view/pages/ads/inputs";
import Automatics from "@/view/pages/ads/timeHandelers/automatics";
import SettingAds from "@/view/pages/ads/settingAds";
import PicSelector from "@/view/pages/uploadCenter/picSelector";
import inputMaker from "@/view/pages/ads/inputMaker";
import {Bus} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";
import ExtraButtons from "@/view/pages/uiBeautifier/extraButtons";
import Swal from "sweetalert2";
import AgencyCategory from "./agencyCategory";
import GetPanelsNumber from "./getPanelsNumber";

export default {
  name: "divarMulti",
  components: {
    GetPanelsNumber,
    AgencyCategory,
    ExtraButtons,
    ButtonTempl,
    TitleRibbon,
    PicSelector, SettingAds, Automatics, Inputs, NumberSelector, CitySelector, Categoryselector, inputMaker
  },
  props: {
    ui_schema: {
      type: Array,
      default() {
        return []
      },
    },
    deActive: {
      default: false
    },
    fields: {
      type: Array,
      default() {
        return [];
      }
    },
    pageName: {
      type: String,
      default: "ارسال آگهی گروهی"
    }
  },
  data() {
    return {
      picker: '',
      cardParameters: {},
      loading: false,
      auto_pay: false,
      submitMessage: '',
      numbers: [],
      isNational: false,
      namePage: this.pageName,
      schema: {
        category: "",
        location: {
          city: "",
          neighborhood: ""
        },
        contact: {
          chat_enabled: true,
          hide_phone: false,
        },
      }
    }
  },
  methods: {
    getSchema: function (value) {
      this.ui_schema = value;
    },
    getFields: function (val) {
      this.fields = val;
    },
    authenticate(title) {
      this.$modal.showLoading();
      $.ajax({
        url: `${url}/divar/check/title`,
        type: "POST",
        fn: this.authenticate,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
          "Content-type": 'application/json'
        },
        data: JSON.stringify({
          "title": title,
          "city": String(this.schema.location.city),
          "category": this.schema.category
        }),
        msg: false,
        error: (data) => {
          if (data.status === 422) {
            this.$modal.error('خطا', 'لطفا اطلاعات فرم را کامل نمایید.')
          } else {
            this.$modal.error('خطا', 'عنوان مورد نظر قابل قبول نمی باشد.');
          }
        },
        success: (data) => {
          this.sendAds();
        }
      });

    },
    submitAds(number = 0) {
      const data = this.schema;

      if (data.available_at === "") {

        delete data.available_at;
      }
      if (data.expire_at === "") {
        delete data.expire_at;
      }
      const main = this.numbers[number];
      if (!this.$refs.inputs.validate() || !this.$refs.city.validate() || !this.$refs.number.validate() || !this.$refs[main][1].validate())
        return;

      this.authenticate(this.$refs[main][1].$data.title);

      let param = {
        advertise: {
          ...data,
          title: this.$refs[main][1].$data.title,
          description: this.$refs[main][1].$data.description,
          new_price: this.$refs[main][1].$data.price,
          images: this.$refs[main][0].$data.selectedImage,
        },
        available_at: this?.$refs[main][1]?.$data?.adsTimes?.times?.starttime,
        expire_at: this?.$refs[main][1]?.$data?.adsTimes?.times?.endtime,
        auto_pay: this.auto_pay
      };

      param.advertise.contact.phone = main

      if (param.available_at === '' || param.available_at === undefined || param.available_at === null)
        delete param.available_at
      else if (param.expire_at === '' || param.expire_at === undefined || param.expire_at === null)
        delete param.expire_at

      if (param.advertise.new_price == null || param.advertise.new_price === '')
        delete param.advertise.new_price

      this.loading = true
      $.ajax({
        url: `${url}/divar/advertise/send`,
        method: 'POST',
        fn: this.submitAds,
        params: [number],

        msg: (number + 1) >= this.numbers.length,

        redirect: {path: '/adsList/futureList'},
        headers: {
          ACCEPT: 'application/json',
          'Content-Type': 'application/json',
          Authorization: Token
        },
        data: JSON.stringify(param),
        success: (data) => {
          this.loading = false
        },
        error: (data) => {
          this.loading = false
        }
      }).always(data => {
        number++;
        if (number < this.numbers.length)
          this.submitAds(number);
      });
    },
  },
  mounted() {
    Bus.$on("selected_numbers", (val) => {
      this.numbers = val;
    });
    Bus.$on('cityInfo', (value) => {
      this.schema.location.city = value.city;
      if (value.neighborhood === '')
        delete this.schema.location.neighborhood;
      else
        this.schema.location.neighborhood = value.neighborhood;
    });

    Bus.$on('contact', (value) => {
      this.schema.contact.chat_enabled = value.chat_enabled;
      this.schema.contact.hide_phone = value.hide_phone;
      this.auto_pay = value.autoPay;
    });

    Bus.$on('category-current', (current) => {
      this.schema.category = current;
    });

    Bus.$on('national', (value) => {
      this.isNational = value
    });
  },
  watch: {
    numbers: function (val) {
      this.schema.advertise.contact.phone = val;
    },
    isNational: function (val) {
      if (val === true) {
        Swal.fire({
          title: 'خطا!',
          text: 'شما در این دسته مجاز به اعمال آگهی نیستید.',
          icon: "error"
        })

      }
    },

  }
}
</script>

<style scoped>

</style>